import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { PrimaryCTA } from "@/components/revanche/PrimaryCTA";
import { MobileScreen } from "@/components/revanche/MobileScreen";
import { setEmail } from "@/lib/photo";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const EmailScreen = () => {
    const navigate = useNavigate();
    const [email, setEmailVal] = useState("");
    const answers = JSON.parse(localStorage.getItem("revanche_answers") || "{}");
    const prenom = (answers.prenom || "").trim();
    const valid = EMAIL_RE.test(email);

    const submit = async () => {
        if (!valid) return;
        try { await setEmail(email); } catch (e) {}
        navigate("/analyse-en-cours");
    };

    const footer = (
        <div className="flex flex-col gap-3">
            <PrimaryCTA dataTestId="btn-launch-analysis" onClick={submit} disabled={!valid}>
                Lancer mon analyse
            </PrimaryCTA>
            <p className="text-[11px] text-white/70 text-center">
                En continuant, tu acceptes les{" "}
                <a href="/cgu" className="underline text-white">CGU</a> et la{" "}
                <a href="/confidentialite" className="underline text-white">politique de confidentialité</a>.
            </p>
        </div>
    );

    return (
        <MobileScreen footer={footer} dataTestId="email-screen">
            <div className="flex-1 flex flex-col justify-center gap-5">
                <h2 className="font-display font-black uppercase text-white leading-[0.95] tracking-tight" style={{ fontSize: "clamp(28px, 8.5vw, 40px)" }}>
                    {prenom ? `${prenom}, où on t'envoie ton analyse ?` : "Où on t'envoie ton analyse ?"}
                </h2>
                <input
                    data-testid="input-email"
                    type="email"
                    inputMode="email"
                    autoComplete="email"
                    placeholder="ton@email.com"
                    value={email}
                    onChange={(e) => setEmailVal(e.target.value)}
                    onKeyDown={(e) => { if (e.key === "Enter" && valid) submit(); }}
                    className="w-full bg-ink-900 border border-ink-700 rounded-xl px-4 h-14 text-white placeholder:text-revtext-secondary focus:border-revred outline-none"
                    style={{ fontSize: "18px" }}
                />
            </div>
        </MobileScreen>
    );
};

export default EmailScreen;
